import { jsx as _jsx } from "react/jsx-runtime";
import { observer } from 'mobx-react-lite';
import HomePage from '@nedoShared/pages/HomePage';
import CalendarPage from '@pages/CalendarPage';
import DashboardPage from '@pages/dashboard/DashboardPage';
import { useSelectedBrand } from '../hooks/useSelectedBrand';
import ExplorePage from './explore/ExplorePage';
const HomePageWrapper = ({ isClient = false }) => {
    const { isZiphy } = useSelectedBrand();
    if (!isClient) {
        return isZiphy ? _jsx(CalendarPage, {}) : _jsx(DashboardPage, {});
    }
    return isZiphy ? _jsx(HomePage, {}) : _jsx(ExplorePage, {});
};
export default observer(HomePageWrapper);
